import fetch from 'isomorphic-fetch';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';

const getProxiedUrl = (path: string) => {
    return `/bff-api/bark-lead${path}`;
};

export const showPostAJob = async (categoryId: number, curGT?: number, curBK?: number) => {
    try {
        const params = new URLSearchParams();
        if (curGT !== undefined) params.append('curGT', curGT.toString());
        if (curBK !== undefined) params.append('curBK', curBK.toString());
        
        const queryString = params.toString();
        const url = getProxiedUrl(`/show-post-a-job/${categoryId}${queryString ? `?${queryString}` : ''}`);
        
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`show-post-a-job error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error checking post-a-job visibility:', error);
        throw error;
    }
};

export const fetchPostAJob = async (categoryId: number, curGT?: number, curBK?: number) => {
    try {
        const { code, visible: isVisible } = await showPostAJob(categoryId, curGT, curBK);

        if (code !== '00' || !isVisible) {
            return {
                isVisible,
                qaList: []
            };
        }

        const qaListData = await getQaList(categoryId);
        
        return {
            isVisible,
            qaList: qaListData
        };
    } catch (error) {
        console.error('Error fetching post a job data:', error);
        return {
            isVisible: false,
            qaList: []
        };
    }
}

export const getQaList = async (categoryId: number) => {
    try {
        const response = await fetch(getProxiedUrl(`/qa-list/${categoryId}`), {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`qa-list error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        
        return data?.code === '00' ? data?.qaList : [];
    } catch (error) {
        console.error('Error fetching QA list:', error);
        throw error;
    }
};

export const getCompleteQaList = async (barkCategoryId: number) => {
    try {
        const response = await fetch(getProxiedUrl(`/form-qa/${barkCategoryId}`), {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`form-qa error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        
        return data?.code === '00' ? data?.qaList : [];
    } catch (error) {
        console.error('Error fetching QA list:', error);
        throw error;
    }
};

export const getIsRemote = async (categoryId: number) => {
    try {
        const response = await fetch(getProxiedUrl(`/is-national-or-remote/${categoryId}`), {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`is-national-or-remote error! Status: ${response.status}`);
        }

        const data = await response.json();

        return data?.code === '00' ? data?.nationalwide : '';
    } catch (error) {
        console.error('Error checking national/remote status:', error);
        throw error;
    }
};

export const getSellerSkills = async (thirdUrl: string, params: {
    keyword: string;
    categoryIds: string[];
    adSource: string;
}) => {
    try {
        const queryString = getNonFalsyUrlSearchParams(params);
        const response = await fetch(`${thirdUrl}/api/seller-skills/search?${queryString.toString()}`, {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`seller-skills/search error! Status: ${response.status}`);
        }
        
        const data = await response.json();

        return data?.data || [];
    } catch (e) {
        console.error('fetch error', e);
        throw e;
    }
}

export const submitLeadForm = async (data: any) => {
    try {
        const response = await fetch(getProxiedUrl('/submit-lead'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`submit-lead error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error submitting lead:', error);
        throw error;
    }
};
